import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'
import { AccessLevelEnum } from "./types";

export interface IStateCategory {
  id: string,
  accessLevel: AccessLevelEnum,
  isProduct: boolean,
  treePosition: string
}

const initialState: IStateCategory = {
  id: 'root',
  accessLevel: AccessLevelEnum.ReadWrite,
  isProduct: false,
  treePosition: ''
} as IStateCategory;

const categortSlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    selectCategory: (state: IStateCategory, action: PayloadAction<IStateCategory | undefined>) => {
      if (action.payload) {
        state.accessLevel = action.payload.accessLevel;
        state.id = action.payload.id;
        state.isProduct = action.payload.isProduct;
        state.treePosition = action.payload.treePosition;
      }
      else { state.accessLevel = initialState.accessLevel; state.id = 'root'; state.isProduct = false; state.treePosition = '' }
    },
  },
});

export const { selectCategory } = categortSlice.actions;

export default categortSlice.reducer;
